/* Athlete profile — scroll-triggered entrance for the values list.
 *
 * Each value fades in while rising slightly from below (the same
 * athlete-intro-quote-in keyframe the intro quote uses), staggered per item
 * via the inline --value-index custom property. The animation fires once the
 * list scrolls into view rather than on load, since the profile sits below the
 * fold.
 *
 * Progressive enhancement: the collapsed start state lives behind the
 * `anim-ready` class which this script adds, so with JS disabled (or reduced
 * motion) the values stay fully visible.
 */
(function () {
  function initSection(root) {
    const list = root.querySelector('[data-athlete-values]');
    if (!list) return;

    const reduceMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return; // leave the values in their visible resting state

    list.classList.add('anim-ready');

    // No IntersectionObserver (very old browsers): just reveal immediately.
    if (!('IntersectionObserver' in window)) {
      list.classList.add('is-in-view');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in-view');
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(list);
  }

  document.querySelectorAll('.athlete-profile').forEach(initSection);
})();
